import { render, staticRenderFns } from "./ClassSubjectStudentType.vue?vue&type=template&id=0560d335&"
import script from "./ClassSubjectStudentType.vue?vue&type=script&lang=ts&"
export * from "./ClassSubjectStudentType.vue?vue&type=script&lang=ts&"
import style0 from "./ClassSubjectStudentType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports